module.exports = __webpack_public_path__ + "img/14.6837f83c.jpg";